// TODO: replace console.error with logger
let identifyInterface = () => console.warn('initialize identifyInterface with trackerInterfaceInit first...'); // eslint-disable-line no-console
let getIdentityInterface = () => console.warn('initialize getIdentityInterface with trackerInterfaceInit first...'); // eslint-disable-line no-console
let timeEventInterface = () => console.warn('initialize trackTimeInterface with trackerInterfaceInit first...'); // eslint-disable-line no-console
let trackInterface = () => console.error('initialize trackInterface with trackerInterfaceInit first...'); // eslint-disable-line no-console
let updateProfileInterface = () => console.warn('initialize updateProfileInterface with trackerInterfaceInit first...'); // eslint-disable-line no-console
let dynamicDefaultPropertiesInterface = () =>
  console.warn('initialize dynamicDefaultPropertiesInterface with trackerInterfaceInit first...'); // eslint-disable-line no-console

export const trackerInterfaceInit = ({
  identify,
  getIdentity,
  timeEvent,
  track,
  updateProfile,
  dynamicDefaultProperties,
}) => {
  identifyInterface = identify || identifyInterface;
  getIdentityInterface = getIdentity || getIdentityInterface;
  timeEventInterface = timeEvent || timeEventInterface;
  trackInterface = track || trackInterface;
  updateProfileInterface = updateProfile || updateProfileInterface;
  dynamicDefaultPropertiesInterface = dynamicDefaultProperties || dynamicDefaultPropertiesInterface;
};

export const identify = (userId) => identifyInterface?.(userId);
export const getIdentity = () => getIdentityInterface?.();
export const timeEvent = (event) => timeEventInterface?.(event);
export const track = (event, props) => trackInterface?.(event, props);
export const updateProfile = (props) => updateProfileInterface?.(props);
export const dynamicDefaultProperties = () => dynamicDefaultPropertiesInterface?.();
